import { s } from "@kosmod/pancake";
import { define } from "./define";

export const visibilitySourceLogic = define('visibility-source', s.o({
  // enabled: s.bool,
  strength: s.num,
}))